import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
  questionnaire_type:Yup.string().nullable(true).required("The questionnaire type field is required."),
  tax_return_type_value: Yup.string().required("The tax return type field is required."),
  external_due_date: Yup.string().nullable(true).required("The external due date field is required."),
  questionnaire_sending_date: Yup.string().nullable(true).required("The questionnaire sending date field is required."),
});
